import { render, staticRenderFns } from "./AplicationsCenterUioComponent.vue?vue&type=template&id=06271fd8"
import script from "./AplicationsCenterUioComponent.vue?vue&type=script&lang=js"
export * from "./AplicationsCenterUioComponent.vue?vue&type=script&lang=js"
import style0 from "./AplicationsCenterUioComponent.vue?vue&type=style&index=0&id=06271fd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports